import type { Routes } from '@angular/router';

import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideTaxService, taxServiceRoutes } from '@eliboo/tax-service';

import { environment } from '../environments/environment';
import { EmptyComponent } from './empty/empty.component';
import { ShareComponent } from './share/share.component';
import { VxCheckComponent } from './vx-check/vx-check.component';

const routes: Routes = [
  { path: 'empty', component: EmptyComponent },
  { path: 'share', component: ShareComponent },
  {
    path: 'aliyun-captcha',
    loadComponent: () => import('./aliyun-captcha/aliyun-captcha.component').then((m) => m.AliyunCaptchaComponent),
    title: '阿里云验证码',
  },
  {
    path: 'product',
    loadChildren: () => import('./product-list/product-list.module').then((m) => m.ProductListModule),
  },
  {
    path: 'transfer',
    loadChildren: () => import('./transfer/transfer.module').then((m) => m.TransferModule),
  },
  {
    path: 'register',
    // path: 'submit-data',
    component: VxCheckComponent,
    children: [
      {
        path: '',
        loadChildren: () => import('./register/register.module').then((m) => m.RegisterModule),
      },
    ],
  },
  {
    path: 'loan-apply',
    loadComponent: () => import('./forms/loan-apply/loan-apply.component').then((m) => m.LoanApplyComponent),
  },
  {
    path: 'financial-gateway',
    loadComponent: () => import('./financial-gateway/financial-gateway.component').then((m) => m.FinancialGatewayComponent),
  },

  {
    path: 'product-detail',
    loadChildren: () => import('./product-detail/product-detail.module').then((m) => m.ProductDetailModule),
  },
  {
    path: 'product-details',
    loadChildren: () => import('./product-details/product-details.module').then((m) => m.ProductDetailsModule),
  },
  {
    path: 'shops',
    loadChildren: () => import('./product-lists/product-lists.module').then((m) => m.ProductListsModule),
  },
  {
    path: 'product-detail-pay',
    loadChildren: () => import('./product-detail-pay/product-detail-pay.module').then((m) => m.ProductDetailPayModule),
  },
  {
    path: 'client-share',
    loadChildren: () => import('./client-invitation/client-invitation.module').then((m) => m.ClientInvitationModule),
  },
  {
    path: 'channel-bind',
    loadChildren: () => import('./channel-bind/channel-bind.module').then((m) => m.ChannelBindModule),
  },
  {
    path: 'license-status',
    loadChildren: () => import('./license-status/license-status.module').then((m) => m.LicenseStatusModule),
    title: '营业执照待办详情',
  },
  {
    path: 'eliboo-pay',
    loadChildren: () => import('./eliboo-pay/eliboo-pay.module').then((m) => m.ElibooPayModule),
  },
  { path: 'nav', redirectTo: '/doc/eliboo' },
  { path: 'policy', redirectTo: '/doc/eliboo/privacy_policy' },
  { path: 'user-agreement', redirectTo: '/doc/eliboo/user-agreement' },
  { path: 'doc-sdk', redirectTo: '/doc/eliboo/sdk' },
  { path: 'doc-permission', redirectTo: '/doc/eliboo/uses_permission' },
  {
    path: 'doc',
    loadChildren: () => import('./policy/policy.module').then((m) => m.PolicyModule),
  },
  {
    path: 'tutorial',
    loadComponent: () => import('./tutorial/tutorial.component').then((m) => m.TutorialComponent),
  },
  {
    path: 'activity',
    children: [
      {
        path: 'duan-wu',
        loadComponent: () => import('./activity/hello-duan-wu.component').then((m) => m.HelloDuanWuComponent),
      },
    ],
  },
  {
    path: 'tax',
    providers: [
      ...provideTaxService({
        routeHost: 'tax',
        microNgConfig: { appId: 'taxApp' },
        env: {
          production: environment.production,
          baseUrl: environment.taxApi.baseUrl,
          channelApiBaseUrl: environment.taxApi.channelApiBaseUrl,
          clientId: environment.taxApi.clientId,
          clientSecret: environment.taxApi.clientSecret,
          isLocal: environment.taxApi.isLocal,
          nestLocalSuffix: environment.taxApi.nestLocalSuffix,
          uploadPlatform: environment.taxApi.uploadPlatform,
          ossBucket: environment.taxApi.ossBucket,
          ossEndpoint: environment.taxApi.ossEndpoint,
          h5PayBasePath: environment.taxApi.h5PayBasePath,
        },
      }),
    ],
    loadChildren: () => taxServiceRoutes,
  },
  { path: '', redirectTo: '/empty', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // useHash:true
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
